export const DEFAULT_FIELD_VALUE = '-';

export const getValueForField = (value?: any) => {
	if (value === false) {
		return DEFAULT_FIELD_VALUE;
	}

	return value ?? DEFAULT_FIELD_VALUE;
};
